import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../utils";
import PageSubheader from "../../../../components/PageSubheader";
import WebhookForm from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreateWebhook = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.webhook.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-webhook-create"
        goBackURL={backURL}
      />

      <WebhookForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreateWebhook));
